(function () {
  var root = document.querySelector('[data-vipc]');
  var state = window.MGMVipCapture;
  if (!root || !state || !state.active) {
    if (root) root.remove();
    return;
  }

  var TIMER_KEY = 'mgm_vipc_timer';
  var cfg = root.dataset;
  var vipKey = 'mgm_vip_' + cfg.listId;
  var closeAt = Date.parse(cfg.closeAt);
  var delay = Math.max(0, Number(cfg.delay) || 0) * 1000;
  var productPage = cfg.productPage === 'true';
  var dialog = root.querySelector('.vipc__dialog');
  var isOpen = false;
  var subscribed = false;
  var lastFocus = null;

  function read(key, session) {
    try {
      return (session ? sessionStorage : localStorage).getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value, session) {
    try {
      (session ? sessionStorage : localStorage).setItem(key, value);
    } catch (e) {}
  }

  function stillActive() {
    return state.force || (!isNaN(closeAt) && Date.now() < closeAt && (subscribed || !read(vipKey)));
  }

  function drawerOpen() {
    var d = document.getElementById('MGMCartDrawer');
    return !!(d && d.classList.contains('is-open'));
  }

  function cartHasItems() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count > 0; })
      .catch(function () { return false; });
  }

  function track(name, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['track', name, props || {}]);
    } catch (e) {}
  }

  function fillBonus() {
    var bonus = state.bonus;
    var pre = root.querySelector('[data-vipc-bonus-pre]');
    var tpl = bonus && (bonus.kind === 'gift' ? cfg.bonusPreGift : cfg.bonusPre);
    if (!bonus || !bonus.label || !pre || !tpl) return;
    pre.querySelector('[data-vipc-bonus-text]').textContent = tpl.replace('[bonus]', bonus.label);
    pre.hidden = false;
    var sticker = root.querySelector('[data-vipc-sticker]');
    if (sticker && bonus.badge) {
      sticker.querySelector('[data-vipc-sticker-value]').textContent = bonus.badge;
      sticker.hidden = false;
    }
  }

  function subscribeBonusList(bonus, detail) {
    if (!bonus.listId || !detail.email || bonus.listId === cfg.listId) return;
    var attributes = { email: detail.email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (detail.firstName) attributes.first_name = detail.firstName;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { custom_source: bonus.source, profile: { data: { type: 'profile', attributes: attributes } } },
          relationships: { list: { data: { type: 'list', id: bonus.listId } } }
        }
      })
    }).catch(function () {});
  }

  function confirmBonus(detail) {
    var bonus = state.bonus;
    if (!bonus || bonus.applied) return;
    bonus.applied = true;
    subscribeBonusList(bonus, detail);
    try {
      bonus.apply();
    } catch (e) {
      console.warn('[vipc] bonus', e);
    }
    var tpl = bonus.kind === 'gift' ? cfg.bonusGift : cfg.bonusCode;
    root.querySelectorAll('[data-vipc-bonus-done]').forEach(function (el) {
      el.textContent = tpl.replace('[bonus]', bonus.label);
      el.hidden = false;
    });
    root.querySelectorAll('[data-vipc-bonus-pre]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function open(auto) {
    if (isOpen || !stillActive()) return;
    if (getComputedStyle(root).position !== 'fixed') {
      setTimeout(function () { open(auto); }, 150);
      return;
    }
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.documentElement.classList.add('vipc-lock');
    var input = root.querySelector('[data-step-panel]:not([hidden]) input');
    setTimeout(function () {
      (input && window.matchMedia('(min-width: 750px)').matches ? input : dialog).focus({ preventScroll: true });
    }, 60);
    track('VIP Popup Viewed', { auto: !!auto });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('vipc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    setTimeout(function () {
      if (!isOpen) root.hidden = true;
    }, 400);
  }

  root.addEventListener('vip:step', function (e) {
    var step = e.detail.step;
    if (step === 'phone' || step === 'done') {
      subscribed = true;
      confirmBonus(e.detail);
    }
    if (step === 'phone') track('VIP Popup Submitted', {});
  });

  root.querySelectorAll('[data-vipc-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-vipc-open]')) return;
    e.preventDefault();
    open(false);
  });

  fillBonus();

  if (state.force) {
    open(false);
    return;
  }

  if (/^\/(cart|checkout)/.test(location.pathname)) return;

  var fired = false;
  function fire() {
    if (fired || isOpen || drawerOpen() || document.querySelector('.mgm-popup-scratch.is-visible')) return;
    fired = true;
    cartHasItems().then(function (busy) {
      if (!busy && !drawerOpen()) open(true);
      else fired = false;
    });
  }

  if (!productPage && !read(TIMER_KEY, true)) {
    setTimeout(function () {
      write(TIMER_KEY, '1', true);
      fire();
    }, delay);
  }

  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) fire();
  });

  var prevY = window.scrollY;
  var anchorY = prevY;
  var anchorT = Date.now();
  var maxY = prevY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    var t = Date.now();
    if (y > maxY) maxY = y;
    if (y >= prevY) {
      anchorY = y;
      anchorT = t;
    } else if (maxY > 600 && anchorY - y > 150 && (anchorY - y) / Math.max(1, t - anchorT) > 1.2) {
      fire();
    }
    prevY = y;
  }, { passive: true });
})();
